export enum PlaceType {
  PROVINCE = 'PROVINCE',
  LOCALITY = 'LOCALITY',
  AREA = 'AREA',
}
